import { Pipe, PipeTransform } from "@angular/core";
import _ from 'lodash';
import { LobbyStaffStatusGridRecord } from "src/app/lobby/lobby-staff-status/shared/models/lobby-staff-status-grid-record.model";

@Pipe({ name: 'StaffStatusPipe' })
export class StaffStatusPipe implements PipeTransform {
    transform(value: LobbyStaffStatusGridRecord): string {
        if (value.statusId === 1) {
            return "_General_Idle_Text_";
        } else if (value.statusId === 2) {
            return "_General_Assisting_Text_";
        } else if (value.statusId === 3) {
            if (_.isEmpty(value.statusReason)) {
                return '_General_SignedOut_Text_';
            } else {
                return value.statusReason
            }
        } else if (value.statusId === 4) {
            return "_General_SignedOut_Text_";
        }

        throw new Error("Unexpected code path reached!")
    }
}